<template>
    <div class="row">
        <div class="col-sm-12">
            <prospectus-search />
            <div v-show="searching" class="search-spinner"></div>
            
            <prospectus-list />
        </div>
    </div>
</template>

<script>
    import ProspectusSearch from './ProspectusSearch.vue';
    import ProspectusList from './ProspectusList.vue';
    import axios from 'axios';
    import { mapActions, mapState } from 'vuex';

    export default {
        components: {
            ProspectusSearch,
            ProspectusList
        },
        computed: {
            ...mapState([
                'companies',
                'conf',
                'searching'
            ])
        },
        props: {
            config: Object
        },
        methods: {
            ...mapActions([
                'Init'
            ])
        },
        created() {
            this.Init(this.config);
        }
    }
</script>

<style lang="scss">
</style>


// WEBPACK FOOTER //
// source/js/Prospectus3Page/src/App.vue